import { useId } from "react";

import FieldLabel from "./FieldLabel";

const inputClassName =
  "w-full rounded border border-gray-300 p-2.5 text-sm placeholder-gray-400 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-black disabled:cursor-not-allowed disabled:bg-gray-100 disabled:text-gray-500";

export type Address = {
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
};

export const emptyAddress: Address = {
  addressLine1: "",
  addressLine2: "",
  city: "",
  state: "",
  postalCode: "",
  country: "",
};

export const AddressFields = ({
  address,
  onChange,
  required = true,
}: {
  address: Address;
  onChange: (_updatedAddress: Address) => void;
  required?: boolean;
}) => {
  const idPrefix = useId();

  return (
    <div className="grid grid-cols-2 gap-4">
      <div className="flex flex-col gap-y-2 col-span-2">
        <FieldLabel htmlFor={`${idPrefix}-addressLine1`} required={required}>
          Address line 1
        </FieldLabel>
        <input
          id={`${idPrefix}-addressLine1`}
          className={inputClassName}
          value={address.addressLine1}
          onChange={(e) =>
            onChange({ ...address, addressLine1: e.target.value })
          }
          required={required}
        />
      </div>
      <div className="flex flex-col gap-y-2 col-span-2">
        <FieldLabel htmlFor={`${idPrefix}-addressLine2`}>
          Address line 2
        </FieldLabel>
        <input
          id={`${idPrefix}-addressLine2`}
          className={inputClassName}
          value={address.addressLine2}
          onChange={(e) =>
            onChange({ ...address, addressLine2: e.target.value })
          }
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <FieldLabel htmlFor={`${idPrefix}-city`} required={required}>
          City
        </FieldLabel>
        <input
          id={`${idPrefix}-city`}
          className={inputClassName}
          value={address.city}
          onChange={(e) => onChange({ ...address, city: e.target.value })}
          required={required}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <FieldLabel htmlFor={`${idPrefix}-state`} required={required}>
          State
        </FieldLabel>
        <input
          id={`${idPrefix}-state`}
          className={inputClassName}
          value={address.state}
          onChange={(e) => onChange({ ...address, state: e.target.value })}
          required={required}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <FieldLabel htmlFor={`${idPrefix}-postalCode`} required={required}>
          Postal code
        </FieldLabel>
        <input
          id={`${idPrefix}-postalCode`}
          className={inputClassName}
          value={address.postalCode}
          onChange={(e) => onChange({ ...address, postalCode: e.target.value })}
          required={required}
        />
      </div>
      <div className="flex flex-col gap-y-2">
        <FieldLabel htmlFor={`${idPrefix}-country`} required={required}>
          Country
        </FieldLabel>
        <input
          id={`${idPrefix}-country`}
          className={inputClassName}
          value={address.country}
          onChange={(e) => onChange({ ...address, country: e.target.value })}
          required={required}
        />
      </div>
    </div>
  );
};
